import Section from '@/components/layout/Section'
import ScrollReveal from '@/components/ui/ScrollReveal'
import ProjectThumbnail from '@/components/ui/ProjectThumbnail'
import { projects } from '@/data/projects'

export default function WorkGrid() {
  const [featured, ...rest] = projects

  return (
    <Section id="work" className="pt-10 pb-16 md:pb-24">
      <div className="flex flex-col gap-6 md:gap-8">
        <ScrollReveal>
          <ProjectThumbnail project={featured} />
        </ScrollReveal>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {rest.map((project, index) => (
            <ScrollReveal key={project.slug} delay={index * 0.1}>
              <ProjectThumbnail project={project} />
            </ScrollReveal>
          ))}
        </div>
      </div>
    </Section>
  )
}
